import HmacSHA256 from 'crypto-js/hmac-sha256'
import Hex from 'crypto-js/enc-hex'

function sortParams(params) {
    const sortedKeys = Object.keys(params).sort();
    let sortedParams = sortedKeys.map(key => {
        const value = params[key];
        if (value === undefined || value === null || value === '') {
            return ``;
        }
        if (Array.isArray(value)) {
            // 数组的处理方式：将数组元素拼接为字符串，再按照 ASCII 码排序
            const sortedArray = value.map(item => item.toString()).sort();
            return `${key}=${sortedArray.join(',')}`;
        }
        if (typeof value === 'object') {
            // 递归处理嵌套字典
            const flattenedValue = sortParams(value);
            return `${key}=${flattenedValue}`;
        }
        return `${key}=${value}`;
    });

    sortedParams = sortedParams.filter(item => item !== '')
    return sortedParams.join('&');
}

export function signRequest(url, params, timestamp, secretKey) {
    const sortedParams = sortParams(params);
    const dataToSign = `${url}${sortedParams}${timestamp}`;

    const signature = HmacSHA256(dataToSign, secretKey);
    return Hex.stringify(signature)
}



// WEBPACK FOOTER //
// ./src/common/sign.js